import { Any } from "@cede/types";
import xor from "lodash/xor";

export const groupByLength = <T>(array: T[], maxLength: number) => {
  return array.reduce((groups: T[][], item: T, index: number) => {
    const group = groups[groups.length - 1];
    if (index % maxLength === 0) {
      groups.push([item]);
    } else if (group) {
      group.push(item);
    }

    return groups;
  }, []);
};

export const intersectArraysOfObjects = (refField: string, ...arrays: Any[][]): Any[] => {
  return (arrays[0] || []).filter((item) =>
    arrays.slice(1).every((array) => array.find((otherItem) => item[refField] === otherItem[refField])),
  );
};

export const duplicateArrayItems = <T>(array: T[], factor: number): T[] => {
  const finalArray = [...array];

  for (let round = 0; round < factor; round++) {
    for (let i = 0; i < array.length; i++) {
      finalArray.push(array[i] as T);
    }
  }

  return finalArray;
};

export function arraysContainSameElements<T>(array1: T[], array2: T[]): boolean {
  return xor(array1, array2).length === 0;
}

export function isArraySubset<T>(superset: T[], subset: T[]): boolean {
  return subset.every((element) => superset.includes(element));
}

export const awaitAndConcatArrayPromises = async <T>(
  promises: Promise<T[]>[],
  metadata: {
    exchangeId: string;
    functionName: string;
    sentryInstance: Any;
  },
) => {
  const results = await Promise.allSettled(promises);

  let result: T[] = [];
  for (const res of results) {
    if (res.status === "rejected") {
      metadata.sentryInstance.captureException(res.reason, {
        captureContext: {
          extra: {
            exchange: metadata.exchangeId,
            functionName: metadata.functionName,
          },
        },
      });
    } else {
      result = result.concat(res.value);
    }
  }
  return result;
};

export const arrayRandomPick = <T>(array: T[]): T => {
  if (array.length === 0) {
    throw new Error("Array is empty");
  }
  const randomIndex = Math.floor(Math.random() * array.length);
  return array[randomIndex] as T;
};
